import React from 'react';
import { Menu, LogOut ,Loader} from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
import { useDispatch } from 'react-redux';
import { logoutOwner } from '../../redux/ownerSlice';
import { logoutStore } from '../../redux/storeSlice';
import { logoutAdmin } from '../../redux/adminSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useUpdateResource } from '../../hooks/useUpdateResource';
import { getdeviceId } from '../../utils/auth';

interface NavbarProps {
  toggleSidebar: () => void;
  title: string;
  headline: string;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar, title, headline }) => {
  const { accessToken: ownerToken ,  refreshToken: ownerRefreshToken } = useSelector((state: RootState) => state.owner);
  const { accessToken: storeToken ,refreshToken: storeRefreshToken } = useSelector((state: RootState) => state.store);
  const { accessToken: adminToken , refreshToken: adminRefreshToken} = useSelector((state: RootState) => state.admin);
  const dispatch = useDispatch();
  const {loading , updateResource} = useUpdateResource();
  async function handleLogout() {
    if(ownerToken){
      await updateResource("owner/logout",{refreshToken:ownerRefreshToken,deviceId:getdeviceId()},"owner",{method:"POST"});
    }
    else if(storeToken){
      await updateResource("store/logout",{refreshToken:storeRefreshToken,deviceId:getdeviceId()},"store",{method:"POST"});
    }
    dispatch(logoutOwner());
    dispatch(logoutStore());
    dispatch(logoutAdmin());
  }

  return (
    <header className="flex justify-between items-center px-6 py-4">
      <div className="flex items-center gap-4">
        {/* Mobile Menu Button */}
        <button className="block lg:hidden text-primary" onClick={toggleSidebar}>
          <Menu size={28} />
        </button>

        <div>
          {title && <h3 className="text-Black text-xl font-bold tracking-wide capitalize">{title}</h3>}
          {headline && <p className="text-Black font-medium text-[14px]">{headline}</p>}
        </div>
      </div>

      <div className="flex items-center gap-4">
        <LanguageSwitcher />
        <button
          onClick={handleLogout}
          className={`bg-primaryButton text-white px-4 py-2 rounded hover:bg-opacity-85 transition ${loading?" cursor-not-allowed bg-opacity-85":""}`}
        >
          {loading ? <Loader/> :<LogOut/>}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
